"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteById = deleteById;
exports.getById = getById;
exports.queryList = queryList;
exports.save = save;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 制作方法列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuPrimaryMenu/page',
    method: 'get',
    params: query
  });
}

// 保存
function save(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuPrimaryMenu/saveXyMenuPrimaryMenu',
    method: 'post',
    data: data
  });
}

// 删除
function deleteById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuPrimaryMenu/deleteXyMenuPrimaryMenu?id=' + id,
    method: 'get'
  });
}

// 通过id等级信息
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuPrimaryMenu/' + id,
    method: 'get'
  });
}